import {
    Component,
    OnInit,
    NgZone,
    ViewChild,
    ViewContainerRef,
    TemplateRef,
    Input,
    ElementRef,
    Renderer2,
    HostListener
} from '@angular/core';
import { ProductModel , AemService, CustomizationDetails, QtyStepperOptions } from 'abs-ngx-library/src/lib/core';

import { CommonService, UserInfoService , CartService } from 'abs-ngx-library/src/lib/core';

// jQuery declaration
declare let $: any;

@Component({
  selector: 'right-drawer-al-v1',
  templateUrl: './right-drawer-al-v1.component.html',
  styleUrls: ['./right-drawer-al-v1.component.scss']
})

export class RightDrawerALV1Component implements OnInit {
  @ViewChild('rightDrawerContainer', { read: ViewContainerRef, static: true }) rightDrawerContainer: ViewContainerRef;
  @ViewChild('miniCartV2', { read: TemplateRef, static: true }) miniCartV2: TemplateRef<any>;
  @ViewChild('offerDetailV2', { read: TemplateRef, static: true }) offerDetailV2: TemplateRef<any>;
  @ViewChild('couponList', { read: TemplateRef, static: true }) couponList: TemplateRef<any>;
  @ViewChild('bogoDetail', { read: TemplateRef, static: true }) bogoDetail: TemplateRef<any>;
  @ViewChild('substitutionList', { read: TemplateRef, static: true }) substitutionList: TemplateRef<any>;
  @ViewChild('ndcOfferDetail', { read: TemplateRef, static: true }) ndcOfferDetail: TemplateRef<any>;
  @ViewChild('customizeDrawer', { read: TemplateRef, static: true }) customizeDrawer: TemplateRef<any>;
  @ViewChild('prebookSlot', { read: TemplateRef, static: true }) prebookSlot: TemplateRef<any>;

  @Input() configObj: any;

  public calledBy = 'right-drawer';
  public couponListData = {};
  public dataValue = '';
  public gridSource = 'drawer';
  public renderingComponent = '';
  public productList = [];
  public coupon: any = {};
  public product: ProductModel;
  public qtyStepperOptions: QtyStepperOptions;
  public showSpinner = false;
  public isBXGYEligibleOffer = false;
  public upcList: any = [];
  public eligibleUpcList: any = [];
  public detailsDrawerTriggeredComponent = '';
  public customizationDetails: CustomizationDetails =  {}

    sidebar: any;
    sidebarWrapper: any;
    rightDrawer: any;
    myaccount: any;
    backdrop: any;
    signInLabelCaretDown: any;
    sidebarShoppingCartClose: any;
    mobileHamBtn: any;
    rightDrawerClass: string;
    mobileHamCloseBtnClass: string;
    signInLabelCaretUp: string;
    sidebarToggleClass: string;
    myAccountLinkButton: string;

  constructor(
      public zone: NgZone,
      public _commonService: CommonService,
      public elementRef: ElementRef,
      private renderer: Renderer2,
      public _aemService: AemService,
      private _userInfoService: UserInfoService,
      private _cartService :CartService) {
      window['rightdrawerCompAlRef'] = {
          zone: zone,
          component: this
      };
  }


  public ngOnInit() {
      this._commonService.$rightDrawerSource.subscribe(rightDrawerData => {
          this.openRightDrawer(rightDrawerData);
      });

        this.sidebar = $('.myaccount-flyout-wrapper div.sidebar'),
        this.sidebarWrapper = $('.myaccount-flyout-wrapper'),
        this.rightDrawer = $('.sidebar-right-drawer'),
        this.myaccount = $('.sidebar-myaccount-flyout'),
        this.backdrop = $('.myAccount-flyout-backdrop'),
        this.signInLabelCaretDown = $('.button__item.menu-nav__red-caret-down'),
        this.sidebarShoppingCartClose =  $('.right-drawer__close'),
        this.mobileHamBtn = $('.menu-nav__mobile-menu-trigger .menu-nav__icon-container'),
        this.rightDrawerClass =  'sidebar__right-drawer',
        this.mobileHamCloseBtnClass = 'activeMenu',
        this.signInLabelCaretUp = 'menu-nav__red-caret-up',
        this.sidebarToggleClass = 'sidebar--effect',
        this.myAccountLinkButton = '.menu-nav__profile-button';


      this.setupADAFocus();

      // Subscribe to BXGY offer and get the offer details
      this._commonService.$bxgyOffer.subscribe(offer => {
          this.isBXGYEligibleOffer = this._commonService.getIsOfferEligibleBXGY(offer) &&
              (this._commonService.isEmpty(this.configObj?.programType) || this.configObj?.programType === 'abs');
          this.upcList = offer?.upcList || [];
          this.eligibleUpcList = offer?.eligibleUpcList || [];
      });

  }

    // Method to call on resize of window to adjust right drawer position
    @HostListener('window:resize', ['$event'])
    onResize(){
        this.adjustRightDrawerPosition();
    }

  /* open right drawer when click on coupon details
  * SPA application needs to pass userInfo object to set user session
  * */
  public openRightDrawer(rightDrawerData, userInfo?, configObj?) {
      if (rightDrawerData != null || {}) {

          if (userInfo) {
              this._userInfoService.setUserSession(userInfo);
          }

          rightDrawerData.hasOwnProperty('type') ? this.renderingComponent = rightDrawerData.type : '';

          switch (true) {

              case (
                  rightDrawerData.hasOwnProperty('couponList')
                  && rightDrawerData.hasOwnProperty('product')
              ):
              case (
                  rightDrawerData.hasOwnProperty('couponList')
                  && this.renderingComponent === 'coupon-list'
              ):

                  this.couponListData['coupons'] = rightDrawerData.couponList;
                  this.couponListData['product'] = rightDrawerData.product;
                  this.openRightFlyout('multiple-coupon');
                  break;

              case (
                  rightDrawerData.hasOwnProperty('coupon')
                  && rightDrawerData.hasOwnProperty('product')
                  && rightDrawerData.hasOwnProperty('triggeredElement')
              ):

                  this.coupon = this.normalizeCoupon(rightDrawerData.coupon);
                  this.dataValue = `{'c-products-by-upc-drawer': {'offerId': '${this.coupon.offerId}' }}`;
                  this.product = { ...rightDrawerData.product };
                  this.detailsDrawerTriggeredComponent = rightDrawerData.triggeredElement;
                  this.openRightFlyout('single-coupon');
                  break;

              case (
                  rightDrawerData.hasOwnProperty('product')
                  && rightDrawerData.hasOwnProperty('triggeredElement')
                  && rightDrawerData?.type === 'customize-drawer'
              ):

                  this.product = { ...rightDrawerData.product };
                  this.detailsDrawerTriggeredComponent = rightDrawerData.triggeredElement;
                  this.customizationDetails = rightDrawerData.customizationDetails;
                  this.openRightFlyout('customize-drawer');
                  break;

              case (
                  rightDrawerData.hasOwnProperty('product')
                  && rightDrawerData.hasOwnProperty('triggeredElement')
                  && (rightDrawerData?.type === 'prebook-slot')
              ):
                  this.qtyStepperOptions = { ...rightDrawerData.qtyStepperOptions }
                  this.product = { ...rightDrawerData.product };
                  this.detailsDrawerTriggeredComponent = rightDrawerData.triggeredElement;
                  this.openRightFlyout(rightDrawerData?.type);
                  break;
                  

              case (
                  rightDrawerData.hasOwnProperty('product')
                  && rightDrawerData.hasOwnProperty('triggeredElement')
              ):

                  this.product = { ...rightDrawerData.product };
                  this.productList = [{ ...rightDrawerData.product }];
                  this.detailsDrawerTriggeredComponent = rightDrawerData.triggeredElement;
                  this.openRightFlyout('single-coupon');
                  break;

              default:
                  break;
          }

          this.configObj = configObj || rightDrawerData?.configObj || this.configObj;
          if (this.product) {
              this.product.id = this.product?.id != null ? String(this.product.id) : '';
              this.product.itemId = this.product?.itemId != null ? String(this.product.itemId) : '';

              if (this.configObj?.appName === 'cart' && this.product.itemId) {
                  this.product.id = this.product.itemId;
              } else if (!this.product.itemId && this.product.id) {
                  this.product.itemId = this.product.id;
              }
          }

          this.loadComponents();
      }
  }

  // Elevaate calls the exposed javascript method that inturn calls this method through zone.
  public renderCouponComponents(drawerType, couponData, product) {
      this.renderingComponent = drawerType;

      if (drawerType === 'coupon-list') {
          this.couponListData['coupons'] = couponData;
          this.couponListData['product'] = product;

      } else if (drawerType === 'offer-detail') {
          this.coupon = this.normalizeCoupon(couponData);
          this.dataValue = `{'c-products-by-upc-drawer': {'offerId': '${this.coupon.offerId}' }}`;
          this.product = { ...product };

      } else if (drawerType === 'bogo-detail') {
          this.product = { ...product };
          this.productList = [{ ...product }];
      }
      this.loadComponents();
  }

  public loadComponents(component?: string) {
      if (component) {
          this.renderingComponent = component;
      }
      $('right-drawer').addClass('d-none');
      this.renderer.removeClass(this.elementRef.nativeElement, 'd-none');

      switch (this.renderingComponent) {
          case 'mini-cart':
              this.removeExistingEmbeddedView();
              this.rightDrawerContainer.createEmbeddedView(this.miniCartV2);
              break;
          case 'coupon-list':
              this.renderComponent(this.couponList);
              break;
          case 'offer-detail':
              this.renderComponent(this.offerDetailV2);
              break;
          case 'bogo-detail':
              this.renderComponent(this.bogoDetail);
              break;
          case 'substitution-list':
              this.renderComponent(this.substitutionList);
              break;
          case 'ndc-offer-detail':
              this.renderComponent(this.ndcOfferDetail);
              break;
          case 'customize-drawer':
              this.renderComponent(this.customizeDrawer);
              setTimeout(() => {
                  this.sidebar.css({ width: '768px' });
              });
              break;
          case 'prebook-slot':
              this.renderComponent(this.prebookSlot);
              setTimeout(() => {
                  this.sidebar.css({ width: '456px' });
              });
              break;
          case 'default':
              this.removeExistingEmbeddedView();
              this.rightDrawerContainer.createEmbeddedView(this.miniCartV2);
              break;
      }
      this.updateCloseButton();
  }

    // Method to show close button for right drawer if navRedesign  is enabled
    private updateCloseButton() {
        const rightDrawerCloseBtn = $('.sidebar-right-drawer .right-drawer__close');

        rightDrawerCloseBtn.addClass('mini-cart-v2-close-button');
        const navEngineEnabled = !window['SWY']?.['CONFIGSERVICE']?.featureToggleConfig?.isNavigationEngineDisabled;
        if (navEngineEnabled){
            rightDrawerCloseBtn.removeClass('d-none');
            rightDrawerCloseBtn.removeClass('d-lg-block');
            setTimeout(() => rightDrawerCloseBtn.focus(), 0);
            this.adjustRightDrawerPosition();
        }
    }

    // Method to adjust right drawer position based on window width and navRedesign is enabled
    private adjustRightDrawerPosition() {
        if (!window['SWY']?.['CONFIGSERVICE']?.featureToggleConfig?.isNavigationEngineDisabled) {
            if(window.innerWidth < 992) {
                setTimeout(() => $(this.elementRef.nativeElement).children().find(".offer-detail-v2").css({"margin-right": '26px'}), 0);
                this.sidebar.css({top: 0, width : '100%', height: '100%'});
                $('rd-customization').css({top: 0, width : '100%', height: '100%'});
            }
            else {
                this.sidebar.removeAttr('style');
            }
        }
    }

  private renderComponent(component: TemplateRef<any>) {
      this.removeExistingEmbeddedView();
      this.showSpinner = true;
      this.rightDrawerContainer.createEmbeddedView(component);
      this.showSpinner = false;
  }

  private removeExistingEmbeddedView(): void {
      if (this.rightDrawerContainer.length > 0) {
          this.rightDrawerContainer.remove();
      } else {
          return;
      }
  }

  private normalizeCoupon(coupon: any): any {
      const normalizedCoupon = { ...(coupon || {}) };

      normalizedCoupon.offerId =
          normalizedCoupon.offerId ||
          normalizedCoupon.omsOfferId ||
          normalizedCoupon.couponID ||
          normalizedCoupon.couponId ||
          normalizedCoupon.id ||
          '';

      normalizedCoupon.offerPgm =
          normalizedCoupon.offerPgm ||
          normalizedCoupon.offerProgram ||
          normalizedCoupon.offerType ||
          normalizedCoupon.offerProgramType ||
          '';

      return normalizedCoupon;
  }

  public loadTriggeredComponent(coupon) {
    this._cartService.rightDrawerEvent.next({
        'event' : 'closeCartDrawer',
        'data' : []
    });
      switch (this.detailsDrawerTriggeredComponent) {
          case 'mini-cart':
              // hiding right drawer al v1 on back button click
              $('right-drawer').removeClass('d-none');
              this.renderer.addClass(this.elementRef.nativeElement, 'd-none');
              // calling right drawer component to re-load mini-cart as we are still using old mini cart
              window['rightdrawerCompRef'].component.detailsDrawerTriggeredComponent = 'mini-cart';
              window['rightdrawerCompRef'].component.loadTriggeredComponent();
              break;
          case 'coupon-list':
              if (coupon) {
                  const CouponIndex =
                      this.couponListData['coupons'].findIndex(couponListCoupon => couponListCoupon.offerId == coupon.offerId);
                  this.couponListData['coupons'][CouponIndex].status = coupon.status;
                  this.couponListData['coupons'][CouponIndex].deleted = coupon.deleted;
              }
              this.renderComponent(this.couponList);
              this.handleADA();
              break;
      }
  }

  private handleADA() {
      const rightDrawerCloseBtn = $('.right-drawer__close');
      const mobileHamBtn = $('.menu-nav__mobile-menu-trigger .menu-nav__icon-container');

      switch (this.detailsDrawerTriggeredComponent) {
          case 'mini-cart':
              rightDrawerCloseBtn.attr('aria-label', 'close shopping cart');
              mobileHamBtn.attr('aria-label', 'close shopping cart');
              break;
          case 'coupon-list':
              rightDrawerCloseBtn.attr('aria-label', 'close coupons list');
              mobileHamBtn.attr('aria-label', 'close coupons list');
              break;
      }

      if (window.innerWidth < 992) {
          mobileHamBtn.focus();
      } else {
          rightDrawerCloseBtn.focus();
      }
  }

      /**
     * Method opening various flyouts
     * This is used for mini-cart , offer-details, coupon-list and bogo-details flyout.
     * 
     * @param flyout - This says which flyout to open
     * @param couponData - @optional - This is coupon data , it may be a single or array of coupons.
     * @param product - @optional - This is product data.
     */

    closeDrawer = function () {
        const that = this;
        that.sidebar.removeClass(that.sidebarToggleClass);
        that.sidebar.removeClass('sidebar__ada-flag');
        that.sidebar.hasClass(that.rightDrawerClass)? that.sidebar.removeClass(that.rightDrawerClass) : '';
        that.backdrop.is(':visible') ? that.backdrop.hide() : '';
        that.signInLabelCaretDown.hasClass(that.signInLabelCaretUp) ? that.signInLabelCaretDown.removeClass(that.signInLabelCaretUp) : '';
        that.mobileHamBtn.hasClass('activeMenu') == true ?  that.mobileHamBtn.removeClass('activeMenu') : '';
      setTimeout(() => { that.sidebarWrapper.hide() }, 300);
      $('body').hasClass('modal-open')? $('body').removeClass('modal-open') : '';
      $(that.myAccountLinkButton).attr('aria-expanded', 'false');
      // AriaUtil.setAriaHidden(".menu-nav", false);
    };

    public openRightFlyout = function (flyout? , couponData? , product?) {
      const rightDrawerMinicart = $('.sidebar-right-drawer .mini-cart');
      const rightFlyoutTriggeredElement = document.activeElement;

        const that = this;
        const openDrawer =  function() {
            that.sidebarWrapper.show();
            that.myaccount.hide();
            that.rightDrawer.show();
            that.sidebar.addClass(that.sidebarToggleClass);
            that.sidebar.addClass(that.rightDrawerClass);
            // this.calculateFlyoutPosition();
            // this.handleFocus(); adding method from AEM JS into library
            that.handleFocusADA();
        };

        const closeDrawer = function () {
            that.sidebar.removeClass(that.sidebarToggleClass);
            that.sidebar.removeClass('sidebar__ada-flag');
            that.sidebar.hasClass(that.rightDrawerClass)? that.sidebar.removeClass(that.rightDrawerClass) : '';
            that.backdrop.is(':visible') ? that.backdrop.hide() : '';
            that.signInLabelCaretDown.hasClass(that.signInLabelCaretUp) ? that.signInLabelCaretDown.removeClass(that.signInLabelCaretUp) : '';
            that.mobileHamBtn.hasClass('activeMenu') == true ?  that.mobileHamBtn.removeClass('activeMenu') : '';
          setTimeout(() => { that.sidebarWrapper.hide()}, 300);
          $('body').hasClass('modal-open') ? $('body').removeClass('modal-open') : '';
          $(that.myAccountLinkButton).attr('aria-expanded', 'false');
          // AriaUtil.setAriaHidden(".menu-nav", false);
        };

        const closeSideBar = function () {
          const rightFlyoutCloseElements = $('.myAccount-flyout-backdrop, .sidebar__user-welcome__close, .sidebar__user-signInLinks__close, .right-drawer__close, .substitution-list__close, .menu-nav__mobile-menu-trigger .menu-nav__icon-container');
          if(rightFlyoutCloseElements !== null && rightFlyoutCloseElements.length > 0){
              rightFlyoutCloseElements.on('click', function (e) {
                  closeDrawer();
                  that.sidebar.attr('aria-label', "");
                  rightFlyoutTriggeredElement !=null ? (rightFlyoutTriggeredElement as HTMLElement)?.focus() : '';
                  $('.root').children().children().not(':first').removeAttr('aria-hidden');
                  $('.reserve-nav').removeAttr('aria-hidden');
              });
          }
        };
        // set click event for closing right drawer on click on close button
        closeSideBar();

      switch (flyout) {
          case 'my-account':
          if (that.sidebar.hasClass(that.sidebarToggleClass) && that.rightDrawer.is(':visible') == true) {
            that.rightDrawer.hide();
            that.myaccount.show();
            that.backdrop.show();
            that.sidebar.removeClass(that.rightDrawerClass);
            that.signInLabelCaretDown.addClass(that.signInLabelCaretUp);
            that.sidebar.attr('aria-label', "Account options");
            that.mobileHamBtn.attr('aria-label', "close account menu");
            if (window['AB'] && window['AB']['DATALAYER']) {
                window['AB']['DATALAYER'].setB2BModalEvent('modalView', 'account_rightnavigation|view');
            }
          } else if (that.sidebar.hasClass(that.sidebarToggleClass) && that.rightDrawer.is(':visible') == false) {
            that.sidebar.removeClass(that.sidebarToggleClass);
              setTimeout(() => { that.sidebarWrapper.hide() }, 300);
              that.backdrop.hide();
              that.mobileHamBtn.removeClass('activeMenu');
              that.signInLabelCaretDown.removeClass(that.signInLabelCaretUp);
              that.sidebar.attr('aria-label', "");
          } else {
            that.sidebarWrapper.show();
            that.rightDrawer.hide();
            that.myaccount.show();
            that.backdrop.show();
            that.sidebar.addClass(that.sidebarToggleClass);
            that.mobileHamBtn.addClass(that.mobileHamCloseBtnClass);
            that.signInLabelCaretDown.addClass(that.signInLabelCaretUp);
            that.sidebar.attr('aria-label', "Account options");
            that.mobileHamBtn.attr('aria-label', "close account menu");
            if (window['AB'] && window['AB']['DATALAYER']) {
                window['AB']['DATALAYER'].setB2BModalEvent('modalView', 'account_rightnavigation|view');
            }
          }
          break;
          case 'mini-cart':
          if (that.sidebar.hasClass(that.sidebarToggleClass) && (that.myaccount.is(':visible') == true || rightDrawerMinicart === null )) {
            that.callAngMinicartComp();
            that.myaccount.hide();
            that.rightDrawer.show();
            that.sidebar.addClass(that.rightDrawerClass);
            that.backdrop.hide();
            that.handleFocus();
            that.signInLabelCaretDown.removeClass(that.signInLabelCaretUp);
            that.sidebar.attr('aria-label', "Shopping cart");
            that.sidebarShoppingCartClose.attr('aria-label', "close Shopping cart");
            that.mobileHamBtn.attr('aria-label', "close Shopping cart");
            that._modalShowADA();
          } else if (that.sidebar.hasClass(that.sidebarToggleClass) && rightDrawerMinicart !== null ) {
            that.closeDrawer();
            that.backdrop.hide();
            that.mobileHamBtn.removeClass(that.mobileHamCloseBtnClass);
            that.sidebar.attr('aria-label', '');
            that.mobileHamBtn.attr('aria-label', 'Navigation menu');
          } else {
            that.callAngMinicartComp();
            that.openDrawer();
            that.mobileHamBtn.addClass(that.mobileHamCloseBtnClass);
            that.sidebar.attr('aria-label', 'Shopping cart');
            that.sidebarShoppingCartClose.attr('aria-label', 'close Shopping cart');
            that.mobileHamBtn.attr('aria-label', 'close Shopping cart');
            that._modalShowADA();
          }
          break;
          case 'multiple-coupon':
          if (!that.sidebar.hasClass(that.sidebarToggleClass)){
              openDrawer();
          }
          that.mobileHamBtn.hasClass('activeMenu') === false ?  that.mobileHamBtn.addClass(that.mobileHamCloseBtnClass) : '';
          that.sidebar.attr('aria-label', 'coupons list');

          // this.handleFocus(); adding method from AEM JS into library
          that.handleFocusADA();
          that.sidebarShoppingCartClose.attr('aria-label', 'close coupons list');
          that.mobileHamBtn.attr('aria-label', 'close coupons list');
          this.modalShowADA();
          break;
          case 'single-coupon':
          if (!that.sidebar.hasClass(that.sidebarToggleClass)) {
              openDrawer();
          }
          that.mobileHamBtn.hasClass('activeMenu') == false ?  that.mobileHamBtn.addClass(that.mobileHamCloseBtnClass) : '';
          // this.handleFocus(); adding method from AEM JS into library
          that.handleFocusADA();

          that.sidebar.attr('aria-label', "offer details");
          that.sidebarShoppingCartClose.attr('aria-label', "close offer details");
          that.mobileHamBtn.attr('aria-label', "close offer details");
          that.modalShowADA();
          break;
          // These use cases are provided/exposed for Elevaate Functionality on product-cards.
          // flyouts that can be expected from elevaate product-cards are coupon-list, offer-detail and bogo-detail.
          case 'coupon-list':
            that.callAngCouponComp(flyout, couponData, product);
              if (!that.sidebar.hasClass(that.sidebarToggleClass)){
                  openDrawer();
              }
              that.mobileHamBtn.hasClass('activeMenu') == false ?  that.mobileHamBtn.addClass(that.mobileHamCloseBtnClass) : '';
              that.sidebar.attr('aria-label', "coupons list");
              // this.handleFocus(); adding method from AEM JS into library
              that.handleFocusADA();

              that.sidebarShoppingCartClose.attr('aria-label', "close coupons list");
              that.mobileHamBtn.attr('aria-label', "close coupons list");
              that.modalShowADA();

          break;

          case 'offer-detail':
          case 'bogo-detail':
            that.callAngCouponComp(flyout, couponData, product);
              if (!that.sidebar.hasClass(that.sidebarToggleClass)){
                  openDrawer();
              }
              that.mobileHamBtn.hasClass('activeMenu') === false ?  that.mobileHamBtn.addClass(that.mobileHamCloseBtnClass) : '';
              that.handleFocus();
              that.sidebar.attr('aria-label', "offer details");
              that.sidebarShoppingCartClose.attr('aria-label', "close offer details");
              that.mobileHamBtn.attr('aria-label', "close offer details");
              that.modalShowADA();
          break;

          case 'substitution-list':
              if (!that.sidebar.hasClass(that.sidebarToggleClass)) {
                  openDrawer();
              }
              that.mobileHamBtn.hasClass('activeMenu') === false ?  that.mobileHamBtn.addClass(that.mobileHamCloseBtnClass) : '';
              that.handleFocus();
              that.sidebar.attr('aria-label', 'substitution list');
              that.sidebarShoppingCartClose.attr('aria-label', 'close substitution list');
              that.mobileHamBtn.attr('aria-label', 'close substitution list');
          break;

          case 'customize-drawer':
              if (!that.sidebar.hasClass(that.sidebarToggleClass)) {
                  openDrawer();
              }
              that.mobileHamBtn.hasClass('activeMenu') === false ?  that.mobileHamBtn.addClass(that.mobileHamCloseBtnClass) : '';
              // that.handleFocus();
              that.sidebar.attr('aria-label', 'customize');
              that.sidebarShoppingCartClose.attr('aria-label', 'close customize');
              that.mobileHamBtn.attr('aria-label', 'close customize');
              that.modalShowADA();
              break;

          case 'prebook-slot':
              if (!that.sidebar.hasClass(that.sidebarToggleClass)) {
                  openDrawer();
              }
              that.mobileHamBtn.hasClass('activeMenu') === false ? that.mobileHamBtn.addClass(that.mobileHamCloseBtnClass) : '';
              that.sidebar.attr('aria-label', 'customize');
              that.sidebarShoppingCartClose.attr('aria-label', 'close customize');
              that.mobileHamBtn.attr('aria-label', 'close customize');
              that.modalShowADA();
              break;
          // Ends here
      }
  };

   /**
     * Sets ADA functionality when showing coupon-modal modal
     *
     */
   modalShowADA = function() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        const
            closeBtn = '.menu-nav__mobile-menu-trigger',
            ariaHidden = 'aria-hidden',
            p0 = '.unified-header-v2',
            p1 = '.header-version-2,.header-version-4',
            p2 = '.menu-nav',
            p3 = $('secondary-bar') ? '.s_nav_fulfillment' : '.menu-nav__wrapper',
            p4 = '.menu-nav__content',
            p5 = '.myaccount-flyout-wrapper',
            p6 = '.sidebar__right-drawer',
            p7 = '.sidebar-right-drawer',
            p8 = 'global-header',
            p9 = '.secondary-bar-proxy',
            xfClass = '.experiencefragment';

        $(p0).siblings().attr(ariaHidden, true);
        $(p1).siblings().attr(ariaHidden, true);
        $(p2).siblings().attr(ariaHidden, true);
        $(p3).siblings().attr(ariaHidden, true);
        $(p4).siblings().attr(ariaHidden, true);
        $(p5).siblings().not(closeBtn).attr(ariaHidden, true);
        $(p6).siblings().attr(ariaHidden, true);
        $(p7).siblings().attr(ariaHidden, true);
        // For Global header identify the parent experience fragment and add aria-hidden
        $(p8).closest(xfClass).siblings().attr(ariaHidden, true);
        $(p9).siblings().attr(ariaHidden, true);

        $('.menu-nav__mobile-menu-trigger,global-header .right-drawer__close').on('click', () => {
            $(p0).siblings().removeAttr(ariaHidden);
            $(p1).siblings().removeAttr(ariaHidden);
            $(p2).siblings().removeAttr(ariaHidden);
            $(p3).siblings().removeAttr(ariaHidden);
            $(p4).siblings().removeAttr(ariaHidden);
            $(p5).siblings().removeAttr(ariaHidden);
            $(p6).siblings().removeAttr(ariaHidden);
            $(p7).siblings().removeAttr(ariaHidden);
            // For Global header identify the parent experience fragment and remove aria-hidden
            $(p8).closest(xfClass).siblings().removeAttr(ariaHidden);
            $(p9).siblings().removeAttr(ariaHidden);
        });
    }
};

  /**
     * Method taken from AEM right-drawer.js
   */
  handleFocusADA = function(){
    setTimeout(() => {
        this.sidebar.addClass('sidebar__ada-flag');
    }, 500);
    // let isMobile = window.innerWidth < 992 ? true : false;
    // if(isMobile){
    //     mobileHamBtn.focus();
    //     $('.root').children().children().not(':first').attr('aria-hidden', 'true');
    //     $('.reserve-nav').attr('aria-hidden', 'true');
    // } else {
    //     sidebarShoppingCartClose.focus();
    // }

    // removed above for DFTA - the page doesnt use the hamburger menu on mobile
    this.sidebarShoppingCartClose.focus();
  };

  /**
     * Method taken from AEM aria.js
   */
  setupADAFocus() {
    // ADA focus for right-side flyout
    $('body').on('keydown', function(e){
        if (e.which === 27 && $('.myaccount-flyout-wrapper').is(':visible')){
            that.closeDrawer();
        }
    });

    $('.myaccount-flyout-wrapper div.sidebar').on('keydown', function (e) {
        if ((e.which === 9) && ('this:focus')) {
            const focusableEls = '.myaccount-flyout-wrapper div.sidebar';
            const modalContent = $(focusableEls).find('a[href]:visible, button:visible:enabled, textarea:not([disabled]), div[tabindex="0"], input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled]),[tabindex]:not([tabindex="-1"])');
            const firstFocusableEl = modalContent.first()[0];
            const lastFocusableEl = modalContent.last()[0];

            if (e.shiftKey) /* shift + tab */ {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else /* tab */ {
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        }
    });

    const that = this;
    $(document).on('click', function (event) {
        /** README:
         * Sanity check for target element. Sometimes the target element that is required has other DOM elements inside, such as span. 
         * onClick, these elements will be targetted instead. Perform a check against the given classes array and switch to parent as target
         */

        const classes = ['details-link', 'coupon-available', 'coupon-some-clipped', 'coupon-available analytics-enabled',
                       'coupon-some-clipped analytics-enabled', 'coupon-clipped analytics-enabled', 'coupon-list-shop-deal', 'coupon-detail-link',
                       'menu-nav__profile-button', 'single-coupon__details-text__link', 'multiple-coupon__text', 'bogo-coupon__details-text__link',
                       'button__item svg-icon svg-icon-Account', 'account-icon',
                       'button__item menu-nav__red-caret-down d-none d-lg-inline-block menu-nav__red-caret-up', 'menu-nav__red-caret-up',
                       'button__item menu-nav__profile-button-sign-in-up d-none d-lg-inline-block',
                       'button__item menu-nav__red-caret-down d-none d-lg-inline-block', 'cart-count-text', 'cart-price-text', 'mini-cart-icon',
                       'menu-nav__cart button__item', 'ab-cart menu-nav__sub-item-container', 'svg-icon svg-icon-Cart-red',
                       'icon button__item menu-nav__red-caret-down svg-caret-down text-primary d-none d-lg-inline-block',
                       'icon button__item menu-nav__red-caret-down svg-caret-down text-primary d-none d-lg-inline-block menu-nav__red-caret-up',
                       'icon svg-user text-primary', 'icon svg-cart text-primary', 'offer-details dst-offer-details-link',
                       'icon svg-cart text-primary dst__svg-cart', 'coupon-card-offer-details offer-details', 'back-btn-container', 'back-arrow', 'back-btn',
                       'body-text-xs word-underline product-coupon__info__text text-wrap text-left color-neutral-90', 'body-text-xs word-underline border-0 product-coupon__info color-neutral-90 sunshine50 px-2 py-1'];

        const target = event.target;
        const targetClassName = target.className.baseVal ?
            target.className.baseVal : target.className ? target.className :  $(target).parent()[0].className;
        const rightDrawerPosition = $('#menu').position();

        if ($('#menu').is(':visible') && (event.clientX > 0 || event.clientY > 0) &&
            (event.clientX < rightDrawerPosition.left || event.clientY < rightDrawerPosition.top) ) {
            if (classes.indexOf(targetClassName) > -1 || !$('#menu').hasClass('sidebar__ada-flag')) {
                return;
            } else {
                const rightSidebar = $('.myaccount-flyout-wrapper div.sidebar');
                if (rightSidebar.hasClass('sidebar--effect')){
                    that.closeDrawer();
                }
            }
        }
    });

  }


}
